<template>
	<div class="home">
		<img src="../assets/1.jpg" height="768" width="1024"/>
		<img src="../assets/2.jpg" height="768" width="1024"/>
		<img src="../assets/3.jpg" height="768" width="1024"/>
		<img src="../assets/4.jpg" height="768" width="1024"/>
		<img src="../assets/5.jpg" height="768" width="1024"/>
		<img src="../assets/6.jpg" height="768" width="1024"/>
	</div>
</template>

<script>
// @ is an alias to /src

export default {
	name       : 'Home',
	components : {
	}
}
</script>
